import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { getApiErrorBodyFromUnknownError } from "@/features/error/handleError";

export interface LineAdsErrorMessage {
  message: string;
  /** Set only when the fix is to request Data Provider API permission from LINE. */
  requestFormUrl?: string;
}

/**
 * Copy for the three LINE Ads codes, which the global error map leaves to this
 * page. Returns null for any other code; the global snackbar covers those.
 */
export function useLineAdsErrorMessage() {
  const { t } = useTranslation();
  return useCallback(
    (error: unknown): LineAdsErrorMessage | null => {
      switch (getApiErrorBodyFromUnknownError(error)?.code) {
        case "LINE_ADS_INVALID_CREDENTIALS":
          return {
            message: t(
              "applications.lineAds.error.invalidCredentials",
              "The group ID, access key or secret key is incorrect.",
            ),
          };
        case "LINE_ADS_DATA_PROVIDER_PERMISSION_REQUIRED":
          return {
            message: t(
              "applications.lineAds.error.dataProviderPermissionRequired",
              "This group does not have Data Provider API permission yet. Request it from LINE, then connect again.",
            ),
            requestFormUrl: t(
              "applications.lineAds.error.requestFormLink",
              "https://tw.linebiz.com/form/lap-data-provider-API-request/",
            ),
          };
        case "LINE_ADS_UNAVAILABLE":
          return {
            message: t(
              "applications.lineAds.error.unavailable",
              "LINE Ads is not responding. Try again later.",
            ),
          };
        default:
          return null;
      }
    },
    [t],
  );
}
